module.exports = __webpack_public_path__ + "img/piaget-altiplano-ultimate-910p-5.2acb5b01.png";